/**
 * Pricing helpers for a single ReUse (Opisto) part card.
 * BR8: Client PCL = New PCL * 0.6 (i.e. New PCL * (1 - 0.4)); if ReUse Garage price (netPrice)
 * is >= New Garage price, then Client PCL = netPrice * 1.10 instead.
 */
const REUSE_GARAGE_PRICE_MARKUP = 1.1;
const NEW_PCL_DISCOUNT_RATIO = 0.6;

export const parseReuseNetPrice = (price: string | null | undefined): number | undefined => {
  if (price == null || price.trim() === '') {
    return undefined;
  }
  const parsed = Number(price);
  return Number.isFinite(parsed) ? parsed : undefined;
};

export const computeReusePcl = (
  netPrice: number,
  newPcl: number | undefined,
  newGaragePrice: number | undefined,
): number | undefined => {
  if (newGaragePrice !== undefined && netPrice >= newGaragePrice) {
    return netPrice * REUSE_GARAGE_PRICE_MARKUP;
  }

  return newPcl === undefined ? undefined : newPcl * NEW_PCL_DISCOUNT_RATIO;
};

export const computeInclVat = (exclVat: number | undefined, vatRate: number): number | undefined =>
  exclVat === undefined ? undefined : exclVat * (1 + vatRate / 100);
